<template>
    <div class="bg-white">
    <div class="container">
      <h1 class="py-4">
        Market Presence: When searching for used cars
        <strong>OOYYO ALREADY</strong> ranks number 1 in many European countries
      </h1>
      <div class="row">
        <div class="col-12 col-lg-6 mb-sm-2">
          <img src="@/images/invest/g-position-es.png" class="w-100" />
        </div>
        <div class="col-12 col-lg-6">
          <img src="@/images/invest/g-position-it.png" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</template>